import { render, staticRenderFns } from "./UpcomingRepayments.vue?vue&type=template&id=270594bd&scoped=true"
import script from "./UpcomingRepayments.vue?vue&type=script&lang=js"
export * from "./UpcomingRepayments.vue?vue&type=script&lang=js"
import style0 from "./UpcomingRepayments.vue?vue&type=style&index=0&id=270594bd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270594bd",
  null
  
)

export default component.exports